import { LitElement, html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

import translate from '../../utils/webcomponents/translate';

import Tooltip from '../tooltip';
class TransactionLookupForm extends LitElement {
	static get properties() {
		return {
			fields: { type: Array },
		};
	}

	firstUpdated() {
		this.createTooltips();
	}

	render() {
		const labelSubmit = translate('lookuptransaction', 'submit', 'Submit');

		return html`
			<div clsas="transaction-lookup__form-fields">
				<div class="form__row">${this.renderFields()}</div>
			</div>
			<div class="stack stack--row">
				<div class="stack__item">
					<button
						type="submit"
						class="button"
					>
						${labelSubmit}
					</button>
				</div>
			</div>
		`;
	}

	renderFields() {
		return this.fields.map(
			(field) => html`
				<div class="form__row-section ${ifDefined(field.classNames ?? '')}">
					<div class="field">
						<label
							class="field__label"
							for="${field.id}"
						>
							${field.label}
							<x-icon
								class="text-brand"
								icon="question"
								size="s"
								data-option-tooltip-placement="top"
								data-option-tooltip-text="${this.getTooltipTranslation(field)}"
							>
							</x-icon>
						</label>
						<div class="form__row form__row--nowrap">
							${field.fields.map(
								(f) => html`
									<div class="form__row-section">
										<input
											class="field__input"
											id="${f.name}"
											name="${f.name}"
											placeholder="${ifDefined(f.placeholder ?? undefined)}"
											min=${ifDefined(f.min ?? undefined)}
											max=${ifDefined(f.max ?? undefined)}
											step=${ifDefined(f.step ?? undefined)}
											value=${ifDefined(f.value ?? undefined)}
											type="${f.type}"
											required
										/>
									</div>
								`,
							)}
						</div>
					</div>
				</div>
			`,
		);
	}

	createTooltips() {
		const tooltips = Array.from(this.querySelectorAll('[data-option-tooltip-text]'));

		tooltips.forEach((tooltip) => new Tooltip(tooltip).start());
	}

	getTooltipTranslation(field) {
		return translate('lookuptransaction', `tooltip${field.id}`, field.id);
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-transaction-lookup-form', TransactionLookupForm);

export default TransactionLookupForm;
